import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../../api/generated';
import { KendoLoading } from '../../../../../../components';
import { ILocationItem } from '../../../../../../components/custom/LocationTree';
import { IWindowComponentProps } from '../../../../../../components/windows/WindowContext';
import * as enums from '../../../../../../enums';
interface LocationConfigInfoScreenLocationsEditWindowProps {
    fetchData: () => Promise<void>;
    unselectedLocations: ILocationItem[];
    editableItemId: number;
}

interface IInfoScreenLocationDisplayItem {
    id: number;
    locationId: number | null;
    direction: enums.InfoScreenLocationDisplayDirectionType;
}

const validationSchema = Yup.object<IInfoScreenLocationDisplayItem>().shape({
    locationId: Yup.number().required('Šis laukas yra privalomas'),
    direction: Yup.number().required('Šis laukas yra privalomas')
});

const LocationConfigInfoScreenLocationsEditWindow: FC<IWindowComponentProps<LocationConfigInfoScreenLocationsEditWindowProps>> = (props) => {
    const {
        componentProps: { unselectedLocations, fetchData, editableItemId },
        onClose
    } = props;

    const [editableItem, setEditableItem] = useState<IInfoScreenLocationDisplayItem | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const resp = await api.administration.getInfoScreenDisplayLocationById(editableItemId);
            setEditableItem(resp);
        };

        fetchData();
    }, []);

    const handleSubmit = async (values: IInfoScreenLocationDisplayItem) => {
        setIsLoading(true);
        try {
            await api.administration.updateInfoScreenDisplayLocation({ ...values });
            toast.success('Atvaizduojama lokacija info ekranui priskirta sėkmingai');
        } catch (ex) {
            toast.error(ex.error[0]);
        } finally {
            setIsLoading(false);
            fetchData();
            onClose();
        }
    };

    const mapLocationsOptions = (unselectedLocations: ILocationItem[]): fabric.IDropdownOption[] => {
        var options: fabric.IDropdownOption[] = [];
        unselectedLocations.map((x) => {
            options.push({ key: x.id.toString(), text: x.name ? x.name : '' });
        });
        return options;
    };

    return (
        <>
            {isLoading ? (
                <KendoLoading />
            ) : (
                <>
                    {editableItem && (
                        <div className="ms-Grid" dir="ltr">
                            <formik.Formik
                                validationSchema={validationSchema}
                                initialValues={{
                                    id: editableItemId,
                                    locationId: editableItem.locationId,
                                    direction: editableItem.direction
                                }}
                                onSubmit={handleSubmit}
                            >
                                {(formikProps) => (
                                    <formik.Form>
                                        <div className="ms-Grid-row">
                                            <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                                                <formik.Field name="locationId">
                                                    {({ field, form }: formik.FieldProps) => (
                                                        <fabric.Dropdown
                                                            {...field}
                                                            options={mapLocationsOptions(unselectedLocations)}
                                                            label="Lokacija"
                                                            onChange={({}, value: any) => form.setFieldValue(field.name, value.key)}
                                                            defaultSelectedKey={field.value.toString()}
                                                        />
                                                    )}
                                                </formik.Field>
                                            </div>
                                            <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                                                <formik.Field name="direction">
                                                    {({ field, form }: formik.FieldProps) => (
                                                        <fabric.Dropdown
                                                            defaultSelectedKey={field.value}
                                                            {...field}
                                                            onChange={({}, option?: fabric.IDropdownOption) =>
                                                                option && form.setFieldValue(field.name, option.key)
                                                            }
                                                            label="Rodyklė"
                                                            options={enums.infoScreenLocationDisplayDirectionType.displayTypesArray()}
                                                            errorMessage={
                                                                (formikProps.status && formikProps.status.direction) || form.errors.direction
                                                            }
                                                        />
                                                    )}
                                                </formik.Field>
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                            <fabric.PrimaryButton
                                                className="ms-slideRightIn40 ms-textAlignRight"
                                                text="Išsaugoti"
                                                disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                                                type="submit"
                                            />
                                        </div>
                                    </formik.Form>
                                )}
                            </formik.Formik>
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default LocationConfigInfoScreenLocationsEditWindow;
